import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { solarServicePages } from "@/data/solarServiceContent";

export const Route = createFileRoute("/services/tesla-powerwall-installation")({
  head: () => ({
    meta: [
      { title: "Tesla Powerwall Installation in Southern California – McKay Roofing & Solar" },
      { name: "description", content: "Certified Tesla Powerwall installation in Southern California. Backup power and smarter solar use, installed the right way." },
      { property: "og:title", content: "Tesla Powerwall Installation – McKay Roofing & Solar" },
      { property: "og:description", content: "Certified Powerwall installs paired cleanly with your solar system." },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/tesla-powerwall-installation" }],
  }),
  component: () => <RoofingServicePage {...solarServicePages["tesla-powerwall-installation"]} />,
});